import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { FaRegMessage } from "react-icons/fa6";
import { IoClose, IoPricetagsOutline } from "react-icons/io5";
import { MdCall, MdOutlineCalendarToday } from "react-icons/md";
import { PiArrowsDownUpBold } from "react-icons/pi";
import { RiFileList2Line } from "react-icons/ri";
import { useHistory } from "react-router-dom";
import DataRolloverIcon from "../../assets/elements/DataRolloverIcon";
import { CALLS_AND_SMS, DATA_CALLS_SMS, DATA_ONLY, RECURRING_BUNDLE_ID } from "../../Common/Constant";
import DashboardDetailsService from "../../Services/DashboardDetailsService";
import UserVarificationService from "../../Services/UserVarificationService";
import AlertPopup from "../Alert_Popup/AlertPopup";
import ListComponent from "./ListComponent";

const ModalPopup = ({ setRecurringModal, modalData, subPlan, isTopPlan }) => {
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [showLogin, setShowLoginPopUp] = useState(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [plan, setPlan] = useState([]);
  const [chooseOption, setChooseOption] = useState(0);

  useEffect(() => {
    //console.log("Modal Data:", subPlan, "====", modalData);

    setPlan(modalData)
  }, [modalData]);

  const updateLoginPopupStatus = () => {
    setShowLoginPopUp(false);
  };

  const LoginCtaBtn = () => {
    return (
      <button
        className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1"
        onClick={loginClicked}
      >
        <font>LOGIN</font>
      </button>
    );
  };

  const loginClicked = () => {
    history.push(`/login`);
  };

  useEffect(() => {
    setIsLoading(true);
    if (!modalData.planId || !isTopPlan) {
      // console.log("plan.planId", plan)
      // Retrieve the planId from the URL parameter
      localStorage.removeItem("topUpIccid");
      localStorage.removeItem("myEsimList");
      localStorage.removeItem("topUpList");
    }
    setIsLoading(false);
  }, [plan.planId, plan]);

  const toggleBuy = (planId) => {
    // console.log("planId", planId)
    // Check user verification status in local storage
    const email = localStorage.getItem("emailId");
    //console.log("email", email)

    if (!email || email === "" || email === undefined || email === null) {
      setShowLoginPopUp(true);
    } else if (email || email !== "" || email !== undefined) {
      // var userVerificationStatus = localStorage.getItem("userVerificationStatus");
      // if(localStorage.getItem("userVerificationStatus") == 0){
      if (localStorage.getItem("token")) {
        const token = localStorage.getItem("token");
        const user = jwtDecode(token);
        const exp = user.exp;
        const currentTime = Math.floor(Date.now() / 1000);
        if (exp < currentTime) {
          localStorage.clear();
          history.push("/");
        }
        UserVarificationService.getVerificationStatus(
          localStorage.getItem("userId")
        ).then((response) => {
          if (response.status == 200) {
            // localStorage.setItem("userVerificationStatus", response.data);
            const userVerificationStatus = response.data;
            if (!userVerificationStatus || userVerificationStatus === "0") {
              // Show popup for unverified user
              setShowVerifyPopup(true);
            } else if (
              userVerificationStatus ||
              userVerificationStatus === "1"
            ) {
              // User is verified
              DashboardDetailsService.dashboardDetailService(
                localStorage.getItem("userId")
              ).then((response) => {
                if (response.status === 200) {
                  localStorage.setItem(
                    "referralCode",
                    response.data.referralCode
                  );
                  const plan = planId;
                  localStorage.setItem("plan", JSON.stringify(plan));
                  // localStorage.removeItem("topUpIccid");
                  // localStorage.removeItem("topUpList");

                  history.push({
                    pathname: "/OrderSummary",
                    // state: { plan }
                  });
                }
              });
            }
          }
        });
      } else {
        localStorage.clear();
        history.push("/");
      }
    }
  };


  return (
    <div className="modal-popup notranslate">
      <div className="modal-popup-container">
        <div className="modal-popup-header">
          <h3>{plan.planName}</h3>
          <IoClose onClick={() => setRecurringModal(false)} />
        </div>
        <div className="modal-popup-body">
          {plan.planCategory != null && (plan.planCategory.planCategoryId == DATA_CALLS_SMS || plan.planCategory.planCategoryId == DATA_ONLY) &&
            <ListComponent
              icon={<PiArrowsDownUpBold />}
              keyValue="Data"
              value={plan.data}
              breakLine={true}
            />
          }
          {plan.planCategory != null && (plan.planCategory.planCategoryId == DATA_CALLS_SMS || plan.planCategory.planCategoryId == CALLS_AND_SMS) &&
            <ListComponent
              icon={<MdCall />}
              keyValue="Minutes"
              value={plan.call}
              breakLine={true}
            />}
          {plan.planCategory != null && (plan.planCategory.planCategoryId == DATA_CALLS_SMS || plan.planCategory.planCategoryId == CALLS_AND_SMS) &&
            <ListComponent
              icon={<FaRegMessage />}
              keyValue="Text"
              value={plan.text}
              breakLine={true}
            />}
          <ListComponent
            icon={<MdOutlineCalendarToday />}
            keyValue={plan.bundleType != null && plan.bundleType.bundleTypeId == RECURRING_BUNDLE_ID ? "Duration" : "Validity"}
            // value={plan.validity + " Days"}
            value={plan.bundleType != null && plan.bundleType.bundleTypeId === RECURRING_BUNDLE_ID ? plan.recurringMonth + " Months" : plan.validity + " Days"}
            breakLine={true}
          />
          <ListComponent
            icon={<IoPricetagsOutline />}
            keyValue={plan.bundleType != null && plan.bundleType.bundleTypeId == RECURRING_BUNDLE_ID ? "Renewal Option" : "Top up option"}
            value={plan.topupAvailable ? "Available" : "Not Applicable"}
            breakLine={true}
          />
          <ListComponent
            icon={<RiFileList2Line />}
            keyValue="Order type"
            value={isTopPlan ? (plan.bundleType != null && plan.bundleType.bundleTypeId === RECURRING_BUNDLE_ID ? "Renewal" : "Top up") : "New eSIM"}
            breakLine={true}
          />
          {plan.bundleType != null && plan.bundleType.bundleTypeId === RECURRING_BUNDLE_ID &&
            <ListComponent
              icon={<DataRolloverIcon />}
              keyValue="Data Rollover"
              value={plan.dataRollover ? "Yes" : "No"}
              breakLine={false}
            />}
        </div>
        <div className="w-100 recurring-option-grid" style={{}}>
          {/* Normal card */}
          <div className={`normal-option-card ${chooseOption == 0 ? "option-card-active" : ""}`} onClick={() => {
            setPlan(modalData);
            setChooseOption(0);
          }}>
            <div className="option-card-header"></div>
            <div className="option-card-body">
              <div className="">
                <h3>One Time</h3>
                <p>Payment Type</p>
              </div>
              <span>£{plan.bundleType != null && plan.bundleType.bundleTypeId === RECURRING_BUNDLE_ID ? Number(plan.primaryPlanPrice).toFixed(0) : Number(plan.price).toFixed(0)}</span>
            </div>
          </div>
          {/* Recurring card */}
          {subPlan.length > 0 && (
            subPlan.map((plan, index) => (
              <div className={`recurring-option-card ${index + 1 == chooseOption ? "option-card-active" : ""}`} onClick={() => {
                setPlan(plan);
                setChooseOption(index + 1);
              }}>
                <div className="option-card-header">
                  <span>
                    Save <b>{Number(plan.recurringDiscountPercentage).toFixed(0)}%</b>
                  </span>
                  <h3>£{Number(plan.recurringMonthlyAmount)}*{plan.recurringMonth}m</h3>
                </div>
                <div className="option-card-body">
                  <div>
                    <h3>Recurring</h3>
                    <p>Payment Type</p>
                  </div>
                  <span>£{Number(plan.recurringMonthlyAmount * plan.recurringMonth).toFixed(0)}</span>
                  <p className="strikethrough">£{Number(plan.primaryPlanPrice * plan.recurringMonth).toFixed(0)}</p>
                </div>
              </div>
            ))
          )
          }
        </div>
        <div className="modal-popup-footer d-flex justify-content-center">
          <button onClick={() => {
            toggleBuy(plan);
          }} className="continue-button my-3">Continue</button>
        </div>
        {showLogin && (
          <AlertPopup
            status={"warning"}
            heading={"Login required to proceed"}
            content={"To gain full access please Login"}
            customFunction={<LoginCtaBtn />}
            updateState={updateLoginPopupStatus}
          />
        )}
      </div>
    </div>
  );
};

export default ModalPopup;
